import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import axios from "axios";
import {
  collection,
  getDocs,
  addDoc,
  doc,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";
import Swal from "sweetalert2";
import { Carousel } from "react-bootstrap";

export default function ManageSlider() {
  const [sliders, setSliders] = useState([]);
  const sliderRef = collection(db, "slider");

  /* ================= FETCH ================= */
  const fetchSliders = async () => {
    const snapshot = await getDocs(sliderRef);
    const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
    data.sort((a, b) => a.urutan - b.urutan);
    setSliders(data);
  };

  useEffect(() => {
    fetchSliders();
  }, []);

  /* ================= CLOUDINARY ================= */
  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    const uniqueName = `${Date.now()}_${file.name}`;
    formData.append("file", file, uniqueName);
    formData.append(
      "upload_preset",
      process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET
    );

    const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
    const apiUrl = `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`;

    const res = await axios.post(apiUrl, formData);
    return res.data.secure_url;
  };

  /* ================= TAMBAH ================= */
  const handleAdd = async () => {
    const { value: form } = await Swal.fire({
      title: "Tambah Slider",
      width: 700,
      html: `
        <input type="file" id="foto" class="swal2-file">

        <input id="judul" class="swal2-input" placeholder="Judul (opsional)">

        <textarea id="deskripsi" class="swal2-textarea"
          placeholder="Deskripsi (opsional)"
          style="height:100px"></textarea>

        <input id="top" type="number" class="swal2-input" placeholder="Posisi Top (%)" value="50">
        <input id="left" type="number" class="swal2-input" placeholder="Posisi Left (%)" value="50">
      `,
      showCancelButton: true,
      confirmButtonText: "Simpan",
      preConfirm: () => {
        return {
          file: document.getElementById("foto").files[0],
          judul: document.getElementById("judul").value,
          deskripsi: document.getElementById("deskripsi").value,
          positionTop: Number(document.getElementById("top").value),
          positionLeft: Number(document.getElementById("left").value),
        };
      },
    });

    if (!form || !form.file) {
      return Swal.fire("Oops!", "Foto wajib diisi!", "warning");
    }

    const imageUrl = await uploadToCloudinary(form.file);

    await addDoc(sliderRef, {
      judul: form.judul || "",
      deskripsi: form.deskripsi || "",
      url: imageUrl,
      urutan: sliders.length + 1,
      positionTop: form.positionTop,
      positionLeft: form.positionLeft,
    });

    Swal.fire("Berhasil!", "Slider ditambahkan", "success");
    fetchSliders();
  };

  /* ================= EDIT ================= */
  const handleEdit = async (s) => {
    const { value: form } = await Swal.fire({
      title: "Edit Slider",
      width: 700,
      html: `
        <input type="file" id="foto" class="swal2-file">
        <small style="display:block;margin-bottom:10px">
          Kosongkan jika tidak ingin ganti foto
        </small>

        <input id="judul" class="swal2-input" value="${s.judul || ""}">
        <textarea id="deskripsi" class="swal2-textarea"
          style="height:100px">${s.deskripsi || ""}</textarea>

        <input id="top" type="number" class="swal2-input" value="${s.positionTop}">
        <input id="left" type="number" class="swal2-input" value="${s.positionLeft}">
      `,
      showCancelButton: true,
      confirmButtonText: "Update",
      preConfirm: () => {
        return {
          file: document.getElementById("foto").files[0],
          judul: document.getElementById("judul").value,
          deskripsi: document.getElementById("deskripsi").value,
          positionTop: Number(document.getElementById("top").value),
          positionLeft: Number(document.getElementById("left").value),
        };
      },
    });

    if (!form) return;

    let payload = {
      judul: form.judul,
      deskripsi: form.deskripsi,
      positionTop: form.positionTop,
      positionLeft: form.positionLeft,
    };

    if (form.file) {
      payload.url = await uploadToCloudinary(form.file);
    }

    await updateDoc(doc(db, "slider", s.id), payload);
    Swal.fire("Berhasil!", "Slider diperbarui", "success");
    fetchSliders();
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Hapus slider ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, hapus",
    });

    if (!confirm.isConfirmed) return;

    await deleteDoc(doc(db, "slider", id));
    Swal.fire("Terhapus!", "Slider berhasil dihapus", "success");
    fetchSliders();
  };

  /* ================= URUTAN ================= */
  const moveSlider = async (index, direction) => {
    const swapIndex = direction === "up" ? index - 1 : index + 1;
    if (swapIndex < 0 || swapIndex >= sliders.length) return;

    const current = sliders[index];
    const target = sliders[swapIndex];

    await updateDoc(doc(db, "slider", current.id), {
      urutan: target.urutan,
    });
    await updateDoc(doc(db, "slider", target.id), {
      urutan: current.urutan,
    });

    fetchSliders();
  };

  /* ================= UI ================= */
  return (
    <div className="container mt-4 pb-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Kelola Slider</h3>
        <button className="btn btn-primary" onClick={handleAdd}>
          + Tambah Slider
        </button>
      </div>

      {/* PREVIEW */}
      {sliders.length > 0 && (
        <>
          <h5 className="mb-3">Preview Slider</h5>
          <Carousel interval={2500}>
            {sliders.map((s) => (
              <Carousel.Item key={s.id}>
                <div
                  style={{
                    position: "relative",
                    height: "350px",
                    overflow: "hidden",
                    borderRadius: "12px",
                  }}
                >
                  <img
                    src={s.url}
                    alt=""
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      filter: "blur(15px) brightness(0.7)",
                    }}
                  />

                  <img
                    src={s.url}
                    alt=""
                    style={{
                      position: "absolute",
                      top: `${s.positionTop}%`,
                      left: `${s.positionLeft}%`,
                      transform: `translate(-${s.positionLeft}%, -${s.positionTop}%)`,
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>

                {(s.judul || s.deskripsi) && (
                  <Carousel.Caption>
                    {s.judul && <h5>{s.judul}</h5>}
                    {s.deskripsi && <p>{s.deskripsi}</p>}
                  </Carousel.Caption>
                )}
              </Carousel.Item>
            ))}
          </Carousel>
        </>
      )}

      {/* LIST */}
      <h5 className="mt-5">Daftar Slider</h5>
      <ul className="list-group">
        {sliders.map((s, i) => (
          <li
            key={s.id}
            className="list-group-item d-flex justify-content-between align-items-center"
          >
            <strong>
              {s.urutan}. {s.judul || "(Tanpa Judul)"}
            </strong>
            <div>
              <button
                className="btn btn-secondary btn-sm me-1"
                onClick={() => moveSlider(i, "up")}
              >
                ↑
              </button>
              <button
                className="btn btn-secondary btn-sm me-2"
                onClick={() => moveSlider(i, "down")}
              >
                ↓
              </button>
              <button
                className="btn btn-warning btn-sm me-2"
                onClick={() => handleEdit(s)}
              >
                Edit
              </button>
              <button
                className="btn btn-danger btn-sm"
                onClick={() => handleDelete(s.id)}
              >
                Hapus
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
